export default __webpack_public_path__ + "static/proibida-03cefe824cfd9eb5ad147494e0a1e544.jpg";